import {Deserializable} from "./deserializable.model";

export class BenchmarkKpiGroup {

   public benchmark_kpi_group_id: number;
   public benchmark_kpi_group_name?;
   public benchmark_kpi_description?;
   public log_types_array?;
   public barnd_type_id?;
   public is_active?;
   public notes?;
   public created_tested?;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): BenchmarkKpiGroup {
    Object.assign(this, input);

    return this;
  }


}
